import { DisposableResource } from './DisposableResource';
import { VideoData } from './VideoData';

export class VideoResource extends DisposableResource<VideoData> {
  static TypeId: string = 'video';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return VideoResource.TypeId;
  }
}
